import { appendTransactionHistory } from '../../helpers/array/array';
import {
  FETCH_EARNING_SUMMARY_FAILURE,
  FETCH_REVERSED_TRANSACTION_FAILURE,
  FETCH_REVERSED_TRANSACTION_START,
  FETCH_REVERSED_TRANSACTION_SUCCESS,
  GET_TRANSACTION_HISTORY_FAILED,
  GET_TRANSACTION_HISTORY_START,
  GET_TRANSACTION_HISTORY_SUCCESS,
} from '../actions/ActionConstant';
import { FETCH_EARNING_SUMMARY_SUCCESS } from '../actions/ActionConstant';
import { FETCH_EARNING_SUMMARY_START } from '../actions/ActionConstant';
import { FETCH_WALLET_HISTORY_SUCCESS } from '../actions/ActionConstant';
import { FETCH_WALLET_HISTORY_FAILURE } from '../actions/ActionConstant';
import { FETCH_WALLET_HISTORY_START } from '../actions/ActionConstant';
import {
  FETCH_WALLET_DETAILS_START,
  FETCH_WALLET_DETAILS_SUCCESS,
  FETCH_WALLET_DETAILS_FAILURE,
  ADD_MONEY_VIA_CARD_START,
  ADD_MONEY_VIA_CARD_SUCCESS,
  ADD_MONEY_VIA_CARD_FAILURE,
} from '../actions/ActionConstant';

const initialState = {
  walletData: {
    data: {},
    loading: true,
    error: false,
  },
  addMoneyViaCard: {
    data: {},
    loading: false,
    error: false,
    buttonDisable: false,
    loadingButtonContent: null,
    successData: {},
  },
  buttonDisable: false,
  loadingButtonContent: null,
  walletHistory: {
    loading: true,
    error: {},
    data: {},
  },
  earningSummary: {
    loading: false,
    error: false,
    data: { stats: [], total: {} },
  },
  reversedTransactions: {
    data: [],
    error: null,
    loading: false,
  },
  transactionHistoryData: {
    data: {
      transactionHistory: [],
      pagination: {}
    },
    loading: null,
    error: null,
  }
};

const WalletReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WALLET_DETAILS_START:
      return {
        ...state,
        walletData: {
          ...state.walletData,
          loading: true,
          error: false,
        },
      };
    case FETCH_WALLET_DETAILS_SUCCESS:
      return {
        ...state,
        walletData: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_WALLET_DETAILS_FAILURE:
      return {
        ...state,
        walletData: {
          ...state.walletData,
          loading: true,
          error: action.error,
        },
      };
    case ADD_MONEY_VIA_CARD_START:
      return {
        ...state,
        addMoneyViaCard: {
          data: action.data,
          loading: true,
          error: false,
          buttonDisable: true,
          loadingButtonContent: 'Processing...',
          successData: {},
        },
      };
    case ADD_MONEY_VIA_CARD_SUCCESS:
      return {
        ...state,
        addMoneyViaCard: {
          data: {},
          loading: false,
          error: false,
          buttonDisable: false,
          loadingButtonContent: null,
          successData: action.data,
        },
      };
    case ADD_MONEY_VIA_CARD_FAILURE:
      return {
        ...state,
        addMoneyViaCard: {
          data: {},
          loading: false,
          error: action.error,
          buttonDisable: false,
          loadingButtonContent: null,
          successData: {},
        },
      };
    case FETCH_WALLET_HISTORY_START:
      return {
        ...state,
        walletHistory: {
          data: {},
          loading: true,
          error: {},
        },
      };
    case FETCH_WALLET_HISTORY_SUCCESS:
      return {
        ...state,
        walletHistory: {
          data: action.data,
          loading: false,
          error: {},
        },
      };
    case FETCH_WALLET_HISTORY_FAILURE:
      return {
        ...state,
        walletHistory: {
          data: {},
          loading: false,
          error: action.error,
        },
      };
    case FETCH_EARNING_SUMMARY_START:
      return {
        ...state,
        earningSummary: {
          data: { stats: [], total: {} },
          loading: true,
          error: false,
        },
      };
    case FETCH_EARNING_SUMMARY_SUCCESS:
      return {
        ...state,
        earningSummary: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_EARNING_SUMMARY_FAILURE:
      return {
        ...state,
        earningSummary: {
          data: { stats: [], total: {} },
          loading: false,
          error: action.error,
        },
      };
    case FETCH_REVERSED_TRANSACTION_START:
      return {
        ...state,
        reversedTransactions: {
          ...state.reversedTransactions,
          loading: true
        },
      };
    case FETCH_REVERSED_TRANSACTION_SUCCESS:
      return {
        ...state,
        reversedTransactions: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_REVERSED_TRANSACTION_FAILURE:
      return {
        ...state,
        reversedTransactions: {
          ...state.reversedTransactions,
          loading: false,
          error: action.error,
        },
      };
    case GET_TRANSACTION_HISTORY_START:
      return {
        ...state,
        transactionHistoryData: {
          ...state.transactionHistoryData,
          // if fresh load (page 1), clear old data; otherwise keep it for pagination
          data: (action.payload.page === 1)
            ? { transactionHistory: [], pagination: {} }
            : state.transactionHistoryData.data,
          error: false,
          loading: true,
        },
      };
    case GET_TRANSACTION_HISTORY_SUCCESS:
      return {
        ...state,
        transactionHistoryData: {
          data: {
            transactionHistory: (action.payload.pagination.page === 1)
              ? action.payload.transactionHistory
              : appendTransactionHistory(
                state.transactionHistoryData?.data?.transactionHistory || [],
                action.payload
              ),
            pagination: action.payload.pagination
          },
          error: false,
          loading: false,
        },
      };
    case GET_TRANSACTION_HISTORY_FAILED:
      return {
        ...state,
        transactionHistoryData: {
          ...state.transactionHistoryData,
          error: action.payload,
          loading: false,
        },
      };

    default:
      return state;
  }
};

export default WalletReducer;
